import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts'

interface BookingStatusChartProps {
    data: {
        CONFIRMED: number
        PENDING_APPROVAL: number
        PENDING_PAYMENT: number
        CANCELED: number
        COMPLETED: number
    }
}

const COLORS: Record<string, string> = {
    CONFIRMED: '#10b981',      // Verde
    PENDING_APPROVAL: '#3b82f6', // Azul
    PENDING_PAYMENT: '#f59e0b',  // Laranja
    CANCELED: '#ef4444',         // Vermelho
    COMPLETED: '#6b7280'         // Cinza
}

const LABELS: Record<string, string> = {
    CONFIRMED: 'Confirmadas',
    PENDING_APPROVAL: 'Aguardando Aprovação',
    PENDING_PAYMENT: 'Aguardando Pagamento',
    CANCELED: 'Canceladas',
    COMPLETED: 'Concluídas'
}

export default function BookingStatusChart({ data }: BookingStatusChartProps) {
    const chartData = Object.entries(data)
        .map(([key, value]) => ({
            name: LABELS[key as keyof typeof LABELS],
            value,
            color: COLORS[key as keyof typeof COLORS]
        }))
        .filter(item => item.value > 0) // Remove itens com valor 0

    return (
        <div className="glass-card p-6">
            <h3 className="text-lg font-black text-primary uppercase mb-4">Status das Reservas</h3>
            <ResponsiveContainer width="100%" height={340}>
                <PieChart>
                    <Pie
                        data={chartData}
                        cx="50%"
                        cy="42%"
                        labelLine={true}
                        label={({ percent }: any) => `${(percent * 100).toFixed(0)}%`}
                        outerRadius={85}
                        fill="#8884d8"
                        dataKey="value"
                    >
                        {chartData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.color} />
                        ))}
                    </Pie>
                    <Tooltip
                        contentStyle={{
                            backgroundColor: '#fff',
                            border: 'none',
                            borderRadius: '12px',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                            padding: '8px 12px',
                            fontSize: '13px',
                            fontWeight: '600'
                        }}
                    />
                    <Legend
                        verticalAlign="bottom"
                        height={50}
                        iconType="circle"
                        wrapperStyle={{ fontSize: '10px', fontWeight: '600', paddingTop: '15px' }}
                    />
                </PieChart>
            </ResponsiveContainer>
        </div>
    )
}
